export default __webpack_public_path__ + "static/media/confrence.0ac4e732.svg";